var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shadow-color-picker-container"},[_c('ColorPicker',{attrs:{"color":_vm.color},on:{"change":_vm.onColorChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }